<template>
  <div>
    <div class="grid">
       <div class="vx-col mb-3 has-text-centered ">
          <h2 class="font-bold">Nombre de la categoría</h2>
           <h3>{{ dish_group.name }}</h3>
       </div>
      
        <div class="vx-col mb-3 has-text-centered">
          <h2 class="font-bold">Productos</h2>
          <div v-if="dish_group.dishes.length>0">
            <tr v-for="dish in dish_group.dishes">
          <h3>{{ dish.name }}</h3>
            </tr>
          </div>
          <div v-else>
           {{ $t('fidelization.NoProductsAssigned') }}
          </div>
        </div>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dish_group: {
      type: Object,
      required: true,
    },
  },
};

</script>
<style>
body {
  font-family: 'Raleway', sans-serif;
  font-size: 12px;
}

</style>
